export const endPoints = {
    GOOGLE_AUTH_LOGOUT: '/v1/google/auth/log-out',
    POST_TELEGRAM_ADD: '/v1/telegram-account/add',
    DELETE_TELEGRAM_REMOVE: '/v1/telegram-account/remove',
    ISHAVE_TELEGRAM: '/v1/telegram-account/isHave'
};
